'use client';

import { useEffect, useRef } from 'react';
import { sendErrorGTMEvent } from '@/components/helpers/analytics/gtm';

export default function NotFoundClient() {
  const hasSentToGtmRef = useRef(false);

  useEffect(() => {
    if (!hasSentToGtmRef.current) {
      sendErrorGTMEvent(404);
      hasSentToGtmRef.current = true;
    }
  }, []);

  return null;
}
